/**
 * lib/query-client.ts — ตั้งค่า TanStack Query
 */

import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // ไม่ retry error ที่เป็นการปฏิเสธโดยตั้งใจ (400/403/404) เพราะลองใหม่ก็ได้ผลเดิม
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

/**
 * query key ทั้งหมดของแอป รวมไว้ที่เดียวกันหมด invalidate ผิดคีย์
 */
export const queryKeys = {
  me: ['auth', 'me'] as const,
  company: ['company'] as const,
  users: ['users'] as const,
  customers: (params: unknown) => ['customers', params] as const,
  suppliers: (params: unknown) => ['suppliers', params] as const,
  products: (params: unknown) => ['products', params] as const,
  expenseCategories: ['expense-categories'] as const,
  expenses: (params: unknown) => ['expenses', params] as const,
  expense: (id: string) => ['expenses', id] as const,
  quotations: (params: unknown) => ['quotations', params] as const,
  quotation: (id: string) => ['quotations', id] as const,
  taxInvoices: (params: unknown) => ['tax-invoices', params] as const,
  taxInvoice: (id: string) => ['tax-invoices', id] as const,
  dashboard: (year: number, month: number) => ['reports', 'dashboard', year, month] as const,
  vatReport: (year: number, month: number) => ['reports', 'vat', year, month] as const,
  monthlySeries: (year: number) => ['reports', 'monthly-series', year] as const,
  googleDriveBackup: ['backup', 'google-drive'] as const,
};

